const state = () => ({
  publicKey: '',
  privateKey: '',
  isLogin: false,
  userToken: '',
  personInfo: {},
  isMembership: false,
  isUser: false,
  personMenu: {},
  userIdentify: '', // 用户求职身份
  isGetCurrentUser: false, // 是否请求过getCurrentUser接口
  purchaseRecordData: null,
  countdownState: true,
});
export default state;